import "./style.scss";
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import { applicationPageSvgConst } from "@/src/svg/applicationsPage/applicationsPageSvgExport";
import BtnDefault from "../../BtnDefault/BtnDefault";
import { useDispatch, useSelector } from "react-redux";
import { IADatabaseFilters } from "@/src/types/admissionDatabase";
import { RootState } from "@/src/store";
import { setFilterAndSearch } from "@/src/store/slices/AdmissionOfficeDatabase/AODatabaseTableSlice";

interface IAPFilterPopUp {
  id: string;
  title: string;
  tableFiltersList: IADatabaseFilters | undefined;
  filterPopUp: string | null;
  setFilterPopUp: Dispatch<SetStateAction<string | null>>;
  setIsCurrentPage: React.Dispatch<React.SetStateAction<string>>;
}

const AODFilterPopUp: FC<IAPFilterPopUp> = ({
  id,
  title,
  tableFiltersList,
  filterPopUp,
  setFilterPopUp,
  setIsCurrentPage,
}) => {
  const dispatch = useDispatch();
  const { filterAndSearch } = useSelector((state: RootState) => state.AODatabaseTable);

  const [keyFilterName, setKeyFilterName] = useState<string>("");
  const [selected, setSelected] = useState<string[]>([]);

  const [dateStart, setDateStart] = useState<string>("");
  const [dateEnd, setDateEnd] = useState<string>(new Date().toISOString().slice(0, 10));

  const [search, setSearch] = useState<string>("");

  const handleEventToggle = (value: string) => {
    setSelected((prev) =>
      prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
    );
  };

  useEffect(() => {
    switch (id) {
      case "course":
        setKeyFilterName("courses");
        break;
      case "nationality":
        setKeyFilterName("nationalities");
        break;
      case "title":
        setKeyFilterName("titles");
        break;
      case "document_type":
        setKeyFilterName("types");
        break;
      case "whose_doc":
        setKeyFilterName("whose_docs");
        break;
    }
  }, [id]);

  const handleEventChooseAll = (mass: IADatabaseFilters | undefined) => {
    switch (id) {
      case "courses":
        setSelected(mass?.courses.map((item) => item) ?? []);
        break;
      case "nationalities":
        setSelected(mass?.nationalities.map((item) => item) ?? []);
        break;
      case "titles":
        setSelected(mass?.titles.map((item) => item) ?? []);
        break;
      case "document_type":
        setSelected(mass?.types.map((item) => item) ?? []);
        break;
      case "whose_docs":
        setSelected(mass?.whose_docs.map((item) => item) ?? []);
        break;
      default:
        setSelected([]);
    }
  };

  const handleEventClearFilters = () => {
    setSelected([]);
    setDateStart("");
    setDateEnd("");
    setSearch("");
  };

  const handleApply = () => {
    dispatch(setFilterAndSearch({ key: keyFilterName, value: selected }));
    console.log("Updated filterAndSearch:", {
      ...filterAndSearch,
      [keyFilterName]: selected,
    });
    setFilterPopUp(null);
    setIsCurrentPage("1");
  };

  // if (id === "color_star") {
  //   return (
  //     <div className={`admission-database-filter ${id === filterPopUp ? "show" : ""}`}>
  //       <div className="admission-database-filter-title">
  //         <p>Star</p>
  //       </div>
  //       <ul className="admission-database-filter-ul">
  //         {tableFiltersList?.color_star.map((item, index) => (
  //           <li className="admission-database-filter-li" key={index}>
  //             <label className="admission-database-filter-li-label">
  //               <input type="checkbox" checked={selected.includes(item)} onChange={() => handleEventToggle(item)} />
  //               <span className="checkmark"></span>
  //             </label>
  //             {item === "default" && <applicationPageSvgConst.StarDefaultSvg />}
  //             {item === "green" && <applicationPageSvgConst.StarGreenSvg />}
  //             {item === "yellow" && <applicationPageSvgConst.StarYellowSvg />}
  //             {item === "black" && <applicationPageSvgConst.StarBlackSvg />}
  //           </li>
  //         ))}
  //       </ul>
  //       <div className="admission-database-filter-actions">
  //         <button type="button" onClick={() => handleEventChooseAll(tableFiltersList)}>
  //           Choose all
  //         </button>
  //         <button type="button" onClick={handleEventClearFilters}>
  //           Clear filters
  //         </button>
  //       </div>
  //       <div className="admission-database-filter-buttons">
  //         <BtnDefault onClick={handleApply}>
  //           <p>Ok</p>
  //         </BtnDefault>
  //         <BtnDefault onClick={() => setFilterPopUp(null)}>
  //           <p>Cancel</p>
  //         </BtnDefault>
  //       </div>
  //     </div>
  //   );
  // }

  if (id === "data_added") {
    const handleClear = () => {
      setDateStart("");
      setDateEnd("");
      setSelected([]);
    };

    const formatDateForDisplay = (isoDate: string) => {
      if (!isoDate) return "";
      const [year, month, day] = isoDate.split("-");
      return `${day}.${month}.${year}`;
    };

    const handleApplyDate = () => {
      const formattedStart = dateStart ? formatDateForDisplay(dateStart) : null;
      const formattedEnd = dateEnd ? formatDateForDisplay(dateEnd) : null;

      console.log(formattedStart, formattedEnd);

      dispatch(
        setFilterAndSearch({
          start: formattedStart,
          end: formattedEnd,
        })
      );

      setFilterPopUp(null);
    };

    return (
      <div className={`admission-database-filter ${id === filterPopUp ? "show" : ""}`}>
        <div className="admission-database-filter-title">
          <p>Date</p>
        </div>

        <div className="admission-database-filter-date">
          <input
            type="date"
            value={dateStart}
            max={dateEnd || undefined}
            onChange={(e) => {
              setDateStart(e.target.value);
              setSelected([e.target.value, dateEnd]);
            }}
          />
          <span className="admission-database-filter-date-to">to</span>
          <input
            type="date"
            value={dateEnd}
            min={dateStart || undefined}
            onChange={(e) => {
              setDateEnd(e.target.value);
              setSelected([dateStart, e.target.value]);
            }}
          />
        </div>

        <div className="admission-database-filter-actions">
          <button type="button" onClick={handleClear}>
            Clear filters
          </button>
        </div>

        <div className="admission-database-filter-buttons">
          <BtnDefault onClick={handleApplyDate}>
            <p>Ok</p>
          </BtnDefault>
          <BtnDefault onClick={() => setFilterPopUp(null)}>
            <p>Cancel</p>
          </BtnDefault>
        </div>
      </div>
    );
  }

  // if (id === "is_read") return null;

  let values: string[] = [];

  if (tableFiltersList) {
    values =
      (tableFiltersList?.[keyFilterName as keyof IADatabaseFilters] as any[])?.map((item) =>
        String(item)
      ) ?? [];
  }
  return (
    <div className={`admission-database-filter ${id === filterPopUp ? "show" : ""}`}>
      <div className="admission-database-filter-title">
        <p>{title}</p>
      </div>

      <div className="admission-database-filter-search">
        <input
          type="text"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <ul className="admission-database-filter-ul">
        {values
          .filter((item) => item.toLowerCase().includes(search.toLowerCase()))
          .map((item, index) => (
            <li className="admission-database-filter-li" key={index}>
              <label className="admission-database-filter-li-label">
                <input
                  type="checkbox"
                  checked={selected.includes(item)}
                  onChange={() => handleEventToggle(item)}
                />
                <span className="checkmark"></span>
              </label>
              <p>{item || "null"}</p>
            </li>
          ))}
      </ul>

      <div className="admission-database-filter-actions">
        <button type="button" onClick={() => handleEventChooseAll(tableFiltersList)}>
          Choose all
        </button>
        <button type="button" onClick={handleEventClearFilters}>
          Clear filters
        </button>
      </div>
      <div className="admission-database-filter-buttons">
        <BtnDefault onClick={handleApply}>
          <p>Ok</p>
        </BtnDefault>
        <BtnDefault onClick={() => setFilterPopUp(null)}>
          <p>Cancel</p>
        </BtnDefault>
      </div>
    </div>
  );
};

export default AODFilterPopUp;
